export interface ExternalURLRouteProps {
  externalURL: string
}

export function ExternalURLRoute(props: ExternalURLRouteProps) {
  window.location.href = props.externalURL
  return <></>
}
